<template>
  <div style="height: 100%;">
    <v-navigation-drawer
      :mini-variant="ismini"
      v-model="drawer"
      width="270"
      app
      class="hidden-print-only primary"
      dark
    >
      <v-toolbar
        style="max-height: 7.5vh;"
        class="primary darken-1 elevation-0"
        dense
        color="transparent"
      >
        <v-toolbar-title class="white--text" v-show="!ismini">{{appName}}</v-toolbar-title>
        <v-spacer v-show="!ismini"></v-spacer>
        <v-icon
          style="margin: 0 auto;"
          color="white"
          @click="clipped = !clipped"
        >{{clipped ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'}}</v-icon>
      </v-toolbar>

      <v-list
        class="scroll-y custom-scrollbar"
        style="max-height: 92.3vh;"
        dense
        active-class="nav-active"
      >
        <template v-for="(item, idx) in filteredItems">
          <v-list-tile v-if="item.to " :to="item.to" exact :key="idx" active-class="nav-active">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-subheader v-if="!item.to" :key="idx">{{item.title}}</v-subheader>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- toolbar -->
    <v-toolbar
      scroll-off-screen
      :scroll-threshold="30"
      fixed
      class="shadow grey lighten-4 hidden-print-only"
      app
      dense
    >
      <v-btn icon @click="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-btn @click="$router.back()" icon>
        <v-icon>{{`${$vuetify.rtl ? 'mdi-arrow-right': 'mdi-arrow-left'}`}}</v-icon>
      </v-btn>
      <v-btn @click="$router.forward()" icon>
        <v-icon>{{`${$vuetify.rtl ? 'mdi-arrow-left': 'mdi-arrow-right'}`}}</v-icon>
      </v-btn>

      <v-btn @click="refresh" icon>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-toolbar-title class="text-capitalize">{{pageTitle}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-menu offset-y>
        <v-btn flat slot="activator">
          {{user.name}}
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile @click="$store.dispatch('auth/logout')">
            <v-list-tile-avatar>
              <v-icon>mdi-power</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>-->

      <v-btn flat icon @click="rightDrawer = true">
        <img src="@/assets/pts.svg" style="width:30px" />
      </v-btn>
    </v-toolbar>

    <v-navigation-drawer
      temporary
      v-model="rightDrawer"
      :right="!$vuetify.rtl"
      class="grey lighten-4"
      app
    >
      <v-list class="pt-0 grey lighten-4">
        <div class="di-flex justify-center py-5 pl-2" style="background:#1b1464">
          <img src="@/assets/pts.svg" style="width:110px" />
        </div>
        <v-divider />

        <v-list-tile @click="$store.dispatch('auth/logout')">
          <v-list-tile-action>
            <v-icon v-html="'mdi-logout'" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-footer fixed height="100">
          <v-layout row wrap justify-start class="pl-4">
            <div class="my-1 di-flex v-middle">
              <v-icon size="22" color="blue darken-1">mdi-email</v-icon>
              <span class="mx-3 body-1">info@pts.af</span>
            </div>
            <div class="my-1 di-flex v-middle">
              <v-icon size="22" color="teal darken-1">mdi-phone</v-icon>
              <span class="ml-3 body-1">0797 103 103</span>
              <strong class="mx-1">-</strong>
              <span class="body-1">0797 106 106</span>
            </div>
          </v-layout>
        </v-footer>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <div class="shadow white round main-content">
        <router-view />
      </div>
    </v-content>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  middleware: "auth",
  data: () => ({
    rightDrawer: false,
    drawer: true,
    clipped: true,
    sideItems: [
      {
        title: "Dashboard",
        roles: ["reception", "finance", "admin"]
      },
      {
        to: "/",
        title: "Dashboard",
        icon: "mdi-view-dashboard",
        roles: ["reception", "finance", "admin"]
      },

      { title: "Reception", roles: ["reception", "admin"] },
      {
        to: "/appointments",
        title: "Appointments",
        icon: "mdi-clock",
        roles: ["reception", "admin"]
      },

      {
        to: "/patients",
        title: "Patients",
        icon: "mdi-account-multiple",
        roles: ["reception", "admin"]
      },

      { title: "Finance", roles: ["finance", "admin"] },

      {
        to: "/payments",
        title: "Payments",
        icon: "mdi-cash",
        roles: ["finance", "admin"]
      },

      {
        to: "/expenses",
        title: "Expenses",
        icon: "mdi-cash",
        roles: ["finance", "admin"]
      },
      { title: "Others", roles: ["admin"] },
      { title: "Appointments", roles: ["doctor"] },
      { title: "Laboratory", roles: ["laboratory"] },
      { title: "Pharmacy", roles: ["pharmacy"] },
      { title: "Procedures", roles: ["procedure"] },
      {
        to: "/doctor/appointments",
        title: "Appointments",
        icon: "mdi-clock",
        roles: ["doctor"]
      },

      {
        to: "/laboratory",
        title: "Laboratory",
        icon: "mdi-test-tube",
        roles: ["laboratory", "admin"]
      },

      {
        to: "/pharmacy",
        title: "Pharmacy",
        icon: "mdi-pharmacy",
        roles: ["pharmacy", "admin"]
      },

      {
        to: "/procedure",
        title: "Procedures",
        icon: "mdi-clock-fast",
        roles: ["procedure", "admin"]
      },

      { title: "Settings", roles: ["admin"] },
      {
        to: "/reports",
        title: "Reports",
        icon: "mdi-chart-line",
        roles: ["admin"]
      },
      {
        to: "/base_info",
        title: "Base Information",
        icon: "mdi-database",
        roles: ["admin"]
      },
      {
        to: "/settings",
        title: "Settings",
        icon: "mdi-settings",
        roles: ["admin"]
      }
    ]
  }),
  methods: {
    refresh() {
      document.location.reload();
    }
  },
  computed: {
    pageTitle() {
      return this.$route.name;
    },
    appName() {
      return "Zaitoon MIS";
    },
    ismini: ({ drawer, clipped }) => drawer && !clipped,
    temp: ({ drawer, clipped }) => !drawer && !clipped,
    ...mapGetters({
      user: "auth/user",
      check: "auth/check"
    }),
    filteredItems() {
      if (!this.check) return false;

      return this.sideItems.filter(i => this.user.hasRoles(i.roles));
    }
  }
};
</script>

<style>
</style>

